import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

function ContactForm() {
  const [error, setError] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)
  const [formData, setFormData] = React.useState({
    name: "",
    company_name: "",
    email: "",
    phone: "",
    message: "",
    subject: "",
  })
  const handleSubmit = (event) => {
    event.preventDefault();
  
    let { name, email, phone, message, subject, company_name } = formData;
  
    setError(false);
    setEmailError(false);
    setPhoneError(false);
    phone = phone.replace(/\D/g, '');
    setFormData((prevData) => ({ ...prevData, phone }));
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!name || !email || !phone || !message || !subject || !company_name) {
      setError(true);
      return;
    }
  
    if (!emailRegex.test(email)) {
      setEmailError(true);
      return;
    }
  
    if (phone.length > 13) {
      setPhoneError(true);
      return;
    }
  
    const serviceID = "service_v7gan2l";
    const templateID = "template_wnk2hma";
    const publicKey = "lO1PFAVrfhoLWzn19";
    const templateParams = { ...formData, phone };
  
    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log("Email sent successfully!", response);
        Swal.fire({
          icon: 'success',
          title: 'Message Sent',
          text: 'Your message has been sent successfully!',
        });
        setFormData({
          name: "",
          company_name: "",
          email: "",
          phone: "",
          message: "",
          subject: "",
        });
      })
      .catch((error) => {
        console.error("Email sending failed!", error);
        Swal.fire({
          icon: 'error',
          title: 'Send Failed',
          text: 'Something went wrong. Please try again later.',
        });
      });
  };
  





  return (
    <section className="ttm-row padding_bottom_zero-section clearfix">
      <div className="container">
        {/* row */}
        <div className="row">
          <div className="col-lg-12">
            <div className="ttm-bgcolor-white box-shadow p-50">
              {/* section title */}
              <div className="section-title title-style-center_text">
                <div className="title-header">
                  <h2 className="title">Contact <b>Form</b></h2>
                </div>
                <div className="title-desc">
                  <p>Feel free to contact us through <a className="ttm-textcolor-skincolor" target="_blank" href="https://twitter.com/NaskInternatio1">Twitter</a> or <a className="ttm-textcolor-skincolor" target="_blank" href="https://www.facebook.com/naskinternational/">Facebook</a> if you prefer.</p>
                </div>
              </div>{/* section title end */}
              <form id="request_qoute_form" onSubmit={handleSubmit} className="request_qoute_form wrap-form clearfix" method="post" noValidate="novalidate">
                <div className="row">
                  <div className="col-md-4">
                    <span className="text-input"><input name="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} type="text" placeholder="Your Name" required />
                      {error && formData.name == '' ? <p className='text_input_validation'>Name is required</p> : ''}
                    </span>
                  </div>
                  <div className="col-md-4">
                    <span className="text-input"><input name="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} type="email" placeholder="Your Email" required />
                      {error && formData.email === '' && (
                        <p className='text_input_validation'>Email is required</p>
                      )}
                      {emailError && formData.email !== '' && (
                        <p className='text_input_validation'>Must include '@' and '.' in a valid format</p>
                      )}
                    </span>
                  </div>
                  <div className="col-md-4">
                    <span className="text-input"><input name="phone" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} type="text" placeholder="Phone Number" required />
                    {error && formData.phone === '' && (
                        <p className='text_input_validation'>Phone Number is required</p>
                      )}
                      {phoneError && formData.phone !== '' ? (
                        <p className='text_input_validation'>Must not be  greater then 13 digits</p>
                      ):''}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <span className="text-input"><input name="company_name" value={formData.company_name}  onChange={(e) => setFormData({ ...formData, company_name: e.target.value })} type="text" placeholder="Company Name*" required />
                      {error && formData.company_name == '' ? <p className='text_input_validation'>Company Name is required</p> : ''}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <span className="text-input"><input name="subject" value={formData.subject}  onChange={(e) => setFormData({ ...formData, subject: e.target.value })} type="text" placeholder="Subject" required />
                      {error && formData.subject == '' ? <p className='text_input_validation'>Subject is required</p> : ''}
                    </span>
                  </div>
                  <div className="col-lg-12">
                    <span className="text-input"><textarea name="message" value={formData.message}  onChange={(e) => setFormData({ ...formData, message: e.target.value })} rows={5} placeholder="Message" required defaultValue={""} />
                      {error && formData.message == '' ? <p className='text_input_validation'>Message is required</p> : ''}
                    </span>
                  </div>
                  <div className="col-lg-12">
                    <div className="pt-15 text-center">
                      <p className="cookies padding_bottom20">
                        <input id="cookies-consent" name="cookies-consent" type="checkbox" defaultValue="yes" />
                        <label htmlFor="cookies-consent">Save my name, email, and website in this browser for the next time I comment.</label>
                      </p>
                      <button className="submit ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-fill ttm-btn-color-skincolor" type="submit">Send now!</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>{/* row end */}
      </div>
    </section>

  )
}

export default ContactForm